import whenDomReady from 'when-dom-ready';
// Kentico renders the form field's "Tooltip" property as a title attribute on the form
// control, which the browser shows as its own plain tooltip. This swaps that for an
// info icon next to the field label with a styled bubble on hover/focus.
//
// Only real form controls are matched on purpose - the file uploader also carries a
// title on its inner <label> ("Please select a file"), which is not a field tooltip.
const CONTROL_SELECTOR = '.form-control[title], input[title], select[title], textarea[title], .ktc-checkbox[title]';
function initialise() {
    document.querySelectorAll('.form-field').forEach((field) => {
        // Already processed (forms can be re-rendered by an ajax postback)
        if (field.querySelector('.form-tooltip')) {
            return;
        }
        const control = field.querySelector(CONTROL_SELECTOR);
        const label = field.querySelector('.control-label');
        if (!control || !label) {
            return;
        }
        const tooltipText = (control.getAttribute('title') ?? '').trim();
        if (!tooltipText) {
            return;
        }
        // Drop the native title everywhere in the field, otherwise the browser tooltip
        // would still pop up next to ours (checkboxes carry it on the wrapper too).
        field.querySelectorAll(CONTROL_SELECTOR).forEach((element) => {
            if (element.getAttribute('title')?.trim() === tooltipText) {
                element.removeAttribute('title');
            }
        });
        const trigger = document.createElement('button');
        trigger.type = 'button'; // must not submit the form
        trigger.className = 'form-tooltip';
        trigger.setAttribute('aria-label', tooltipText);
        // Geometry taken from wwwroot/src/img/svg/icon-info.svg, but drawn with currentColor
        // so the icon follows the label colour instead of the orange baked into that file.
        trigger.insertAdjacentHTML('afterbegin', `<svg class="form-tooltip__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M20,12a8,8,0,1,1-8-8A8,8,0,0,1,20,12Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" />
        <path d="M12.9,16.26H11.08V11H12.9v5.26ZM12,10a1.1,1.1,0,0,1-1.12-1.07V8.86a1.09,1.09,0,0,1,1.07-1.12H12a1.09,1.09,0,0,1,1.14,1.07v0A1.12,1.12,0,0,1,12,10Z" fill="currentColor" />
      </svg>`);
        const bubble = document.createElement('span');
        bubble.className = 'form-tooltip__bubble';
        bubble.setAttribute('role', 'tooltip');
        bubble.textContent = tooltipText;
        trigger.appendChild(bubble);
        label.appendChild(trigger);
    });
}
whenDomReady().then(initialise);
